import Icon from '../components/Icon.vue'

Icon.register({
  'file-csv': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM128 280v-16c0-4.4-3.6-8-8-8h-8c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h8c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-8c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h8c4.4 0 8-3.6 8-8zM172.3 384c23.4 0 42.4-17.3 42.4-38.6 0-10.7-4.9-20.9-13.3-28.1l-21.9-18.8c-1.4-1.2-2.1-2.5-2.1-3.8 0-3.1 4.5-6.6 10.4-6.6h12.3c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8h-12.3c-23.4 0-42.4 17.3-42.4 38.6 0 10.7 4.9 20.9 13.3 28.1l21.9 18.8c1.4 1.2 2.1 2.5 2.1 3.8 0 3.1-4.5 6.6-10.4 6.6h-12.3c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h12.3zM256 264c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v20.8c0 35.5 12.9 68.9 36.3 94.1 3 3.3 7.3 5.1 11.7 5.1s8.7-1.9 11.7-5.1c23.4-25.2 36.3-58.6 36.3-94.1v-20.8c0-4.4-3.6-8-8-8h-16c-4.4 0-8 3.6-8 8v20.8c0 20.3-5.7 40.2-16 56.9-10.3-16.7-16-36.6-16-56.9v-20.8zM377 105c4.5 4.5 7 10.6 7 16.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-csv.js
// module id = 1329
// module chunks = 0